/**
 * Limites anti-banimento: intervalo, teto de envios e pausa humana.
 */
import React from 'react';
import Select from '../../../../components/ui/Select';
import Input from '../../../../components/ui/Input';
import {
    MAX_SENDS_PRESET_OPTIONS,
    MIN_INTERVAL_PRESET_OPTIONS,
    PAUSE_TIMEOUT_HOURS_MIN,
} from '../followUp.constants';

interface FollowUpAntiBanFieldsProps {
    minIntervalSeconds: number;
    onMinIntervalSecondsChange: (value: number) => void;
    maxSendsPerCycle: number;
    onMaxSendsPerCycleChange: (value: number) => void;
    pauseTimeoutHours: number | '';
    onPauseTimeoutHoursChange: (value: number | '') => void;
}

function parseNumericInput(value: string, min: number): number | '' {
    if (value === '') return '';
    const parsed = Number(value);
    return Number.isFinite(parsed) && parsed >= min ? parsed : '';
}

export default function FollowUpAntiBanFields({
    minIntervalSeconds,
    onMinIntervalSecondsChange,
    maxSendsPerCycle,
    onMaxSendsPerCycleChange,
    pauseTimeoutHours,
    onPauseTimeoutHoursChange,
}: FollowUpAntiBanFieldsProps) {
    return (
        <section className="rounded-xl border border-border bg-surface p-s4 md:p-s5" aria-labelledby="followup-antiban">
            <h2 id="followup-antiban" className="text-sm font-semibold text-default">
                Limites anti-banimento
            </h2>
            <p className="mt-s1 text-sm text-muted">
                Só valores seguros. Excedentes são reagendados, não perdidos.
            </p>

            <div className="mt-s4 grid grid-cols-1 gap-s4 sm:grid-cols-2">
                <Select
                    label="Intervalo mínimo entre envios"
                    value={String(minIntervalSeconds)}
                    onChange={(event) => onMinIntervalSecondsChange(Number(event.target.value))}
                    options={MIN_INTERVAL_PRESET_OPTIONS}
                    aria-label="Intervalo mínimo entre envios"
                />
                <Select
                    label="Máx. de envios por ciclo"
                    value={String(maxSendsPerCycle)}
                    onChange={(event) => onMaxSendsPerCycleChange(Number(event.target.value))}
                    options={MAX_SENDS_PRESET_OPTIONS}
                    aria-label="Máximo de envios por ciclo"
                />
            </div>

            <Input
                type="number"
                min={PAUSE_TIMEOUT_HOURS_MIN}
                inputMode="numeric"
                placeholder="Padrão: 24"
                value={pauseTimeoutHours}
                onChange={(event) =>
                    onPauseTimeoutHoursChange(parseNumericInput(event.target.value, PAUSE_TIMEOUT_HOURS_MIN))
                }
                label="Pausa após resposta humana (horas)"
                containerClassName="mt-s4"
            />
            <p className="mt-s2 text-sm text-muted">
                Quando a equipe responde, a sequência congela até o lead falar de novo ou até passar esse tempo.
            </p>
        </section>
    );
}
